<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "horizontal-layout",
      class: [_vm.layoutClasses],
      staticStyle: { height: "inherit" },
      attrs: { "data-col": _vm.isNavMenuHidden ? "1-column" : null },
    },
    [
      _c(
        "b-navbar",
        {
          staticClass:
            "header-navbar navbar-shadow align-items-center navbar-brand-center navbar-fixed",
          class: {
            "fixed-top": _vm.$store.getters["app/currentBreakPoint"] !== "xl",
          },
          style: {
            backgroundColor:
              _vm.navbarType === "static" &&
              _vm.scrolledTo &&
              _vm.skin === "light"
                ? "white"
                : null,
            boxShadow:
              _vm.navbarType === "static" && _vm.scrolledTo
                ? "rgba(0, 0, 0, 0.05) 0px 4px 20px 0px"
                : null,
          },
          attrs: { toggleable: false },
        },
        [
          _vm._t(
            "navbar",
            [
              _c("app-navbar-horizontal-layout-brand"),
              _c("app-navbar-horizontal-layout", {
                attrs: {
                  "toggle-vertical-menu-active": _vm.toggleVerticalMenuActive,
                },
              }),
            ],
            { toggleVerticalMenuActive: _vm.toggleVerticalMenuActive }
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "horizontal-menu-wrapper" },
        [
          !_vm.isNavMenuHidden
            ? _c(
                "div",
                {
                  staticClass:
                    "header-navbar navbar-expand-sm navbar navbar-horizontal navbar-light navbar-shadow menu-border d-none d-xl-block",
                  class: [_vm.navbarMenuTypeClass],
                },
                [_c("horizontal-nav-menu")],
                1
              )
            : _vm._e(),
          _c("vertical-nav-menu", {
            staticClass: "d-block d-xl-none",
            attrs: {
              "is-vertical-menu-active": _vm.isVerticalMenuActive,
              "toggle-vertical-menu-active": _vm.toggleVerticalMenuActive,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function (slotProps) {
                    return [
                      _vm._t("vertical-menu-header", null, null, slotProps),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c("div", {
        staticClass: "sidenav-overlay",
        class: _vm.overlayClasses,
        on: {
          click: function ($event) {
            _vm.isVerticalMenuActive = false
          },
        },
      }),
      _c(
        "transition",
        { attrs: { name: _vm.routerTransition, mode: "out-in" } },
        [
          _c(_vm.layoutContentRenderer, {
            key:
              _vm.layoutContentRenderer === "layout-content-renderer-left"
                ? _vm.$route.meta.navActiveLink || _vm.$route.name
                : null,
            tag: "component",
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.$scopedSlots, function (index, name) {
                  return {
                    key: name,
                    fn: function (data) {
                      return [_vm._t(name, null, null, data)]
                    },
                  }
                }),
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "footer footer-light", class: [_vm.footerTypeClass] },
        [_vm._t("footer", [_c("app-footer")])],
        2
      ),
      _vm._t("customizer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/layouts/layout-horizontal/LayoutHorizontal.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import core_layouts_components_AppBreadcrumb_vue from '@core/layouts/components/AppBreadcrumb.vue';
import core_layouts_components_app_navbar_AppNavbarHorizontalLayout_vue from '@core/layouts/components/app-navbar/AppNavbarHorizontalLayout.vue';
import core_layouts_components_app_navbar_AppNavbarHorizontalLayoutBrand_vue from '@core/layouts/components/app-navbar/AppNavbarHorizontalLayoutBrand.vue';
import core_layouts_components_AppFooter_vue from '@core/layouts/components/AppFooter.vue';
import core_app_config_useAppConfig from '@core/app-config/useAppConfig';
import * as bootstrapvue from 'bootstrap-vue';
import core_comp_functions_misc_event_listeners from '@core/comp-functions/misc/event-listeners';
import * as vue_composition_api from '@vue/composition-api';
import core_layouts_components_layout_content_renderer_LayoutContentRendererDefault_vue from '@core/layouts/components/layout-content-renderer/LayoutContentRendererDefault.vue';
import core_layouts_components_layout_content_renderer_LayoutContentRendererLeft_vue from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeft.vue';
import core_layouts_components_layout_content_renderer_LayoutContentRendererLeftDetached_vue from '@core/layouts/components/layout-content-renderer/LayoutContentRendererLeftDetached.vue';
import useLayoutHorizontal from './useLayoutHorizontal';
import components_horizontal_nav_menu_HorizontalNavMenu_vue from './components/horizontal-nav-menu/HorizontalNavMenu.vue';
import core_layouts_layout_vertical_components_vertical_nav_menu_VerticalNavMenu_vue from '@core/layouts/layout-vertical/components/vertical-nav-menu/VerticalNavMenu.vue';
import core_layouts_layout_vertical_useVerticalLayout from '@core/layouts/layout-vertical/useVerticalLayout';
import mixinLayoutHorizontal from './mixinLayoutHorizontal';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// Content Renderer






// Vertical Menu
/* eslint-disable import/order */



/* eslint-enable import/order */

export default ({
  render,
  staticRenderFns,
  components: {
    AppBreadcrumb: core_layouts_components_AppBreadcrumb_vue,
    AppNavbarHorizontalLayout: core_layouts_components_app_navbar_AppNavbarHorizontalLayout_vue,
    AppNavbarHorizontalLayoutBrand: core_layouts_components_app_navbar_AppNavbarHorizontalLayoutBrand_vue,
    AppFooter: core_layouts_components_AppFooter_vue,
    HorizontalNavMenu: components_horizontal_nav_menu_HorizontalNavMenu_vue,
    BNavbar: bootstrapvue["BNavbar"],
    // Content Renderer
    LayoutContentRendererDefault: core_layouts_components_layout_content_renderer_LayoutContentRendererDefault_vue,
    LayoutContentRendererLeft: core_layouts_components_layout_content_renderer_LayoutContentRendererLeft_vue,
    LayoutContentRendererLeftDetached: core_layouts_components_layout_content_renderer_LayoutContentRendererLeftDetached_vue,
    // Vertical Menu
    VerticalNavMenu: core_layouts_layout_vertical_components_vertical_nav_menu_VerticalNavMenu_vue
  },
  mixins: [mixinLayoutHorizontal],
  computed: {
    layoutContentRenderer() {
      const rendererType = this.$route.meta.contentRenderer;
      if (rendererType === 'sidebar-left') return 'layout-content-renderer-left';
      if (rendererType === 'sidebar-left-detached') return 'layout-content-renderer-left-detached';
      return 'layout-content-renderer-default';
    }
  },
  setup() {
    const {
      skin,
      navbarType,
      footerType,
      routerTransition,
      isNavMenuHidden
    } = core_app_config_useAppConfig();

    // Vertical Menu
    const {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      overlayClasses,
      resizeHandler
    } = core_layouts_layout_vertical_useVerticalLayout(navbarType, footerType);

    // Resize handler
    resizeHandler();
    window.addEventListener('resize', resizeHandler);
    vue_composition_api.onUnmounted(() => {
      window.removeEventListener('resize', resizeHandler);
    });
    const {
      navbarMenuTypeClass,
      layoutClasses,
      footerTypeClass
    } = useLayoutHorizontal(navbarType, footerType, isVerticalMenuActive);

    // Scroll Listener
    const {
      scrolledTo
    } = core_comp_functions_misc_event_listeners.useScrollListener();
    return {
      // skin
      skin,
      // Layout
      layoutClasses,
      // Navbar
      navbarType,
      navbarMenuTypeClass,
      // Menu Hidden
      isNavMenuHidden,
      // Router Transition
      routerTransition,
      // Footer
      footerTypeClass,
      // Scroll Listeners
      scrolledTo,
      // Vertical Menu
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      overlayClasses
    };
  }
});

//# sourceURL=webpack:///./src/@core/layouts/layout-horizontal/LayoutHorizontal.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
[dir] .bordered-layout .header-navbar {
  box-shadow: none;
}
[dir] .bordered-layout .header-navbar.floating-nav {
  border: 1px solid #ebe9f1;
}
[dir] .bordered-layout .header-navbar.fixed-top {
  border-bottom: 1px solid #ebe9f1;
  background: #efefef;
}
[dir] .bordered-layout .main-menu {
  box-shadow: none;
}
[dir=ltr] .bordered-layout .main-menu {
  border-right: 1px solid #ebe9f1;
}
[dir=rtl] .bordered-layout .main-menu {
  border-left: 1px solid #ebe9f1;
}
[dir] .bordered-layout .main-menu.menu-light .navigation > li.open:not(.menu-item-closing) > a, [dir] .bordered-layout .main-menu.menu-light .navigation > li.sidebar-group-active > a {
  background: #ededed;
}
[dir] .bordered-layout .dropdown-menu {
  border: 1px solid #ebe9f1 !important;
  box-shadow: none;
}
[dir] .bordered-layout .main-menu .navigation, [dir] .bordered-layout .main-menu {
  background: #efefef;
}
[dir] .bordered-layout .card, [dir] .bordered-layout .bs-stepper:not(.wizard-modern):not(.checkout-tab-steps), [dir] .bordered-layout .bs-stepper.wizard-modern .bs-stepper-content {
  border: 1px solid #ebe9f1;
  box-shadow: none;
}
[dir] .bordered-layout .footer {
  box-shadow: none !important;
}
[dir] .bordered-layout .footer-fixed .footer {
  border-top: 1px solid #ebe9f1;
}
</style>
